import { ArgumentOutOfRangeException } from "../../shared/index.js";
import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const repeatParallel = (element, count, delay) => {
    if (count < 0) {
        throw new ArgumentOutOfRangeException("count");
    }
    if (delay) {
        return repeat2(element, count, delay);
    }
    else {
        return repeat1(element, count);
    }
};
const repeat1 = (element, count) => {
    const generator = async () => {
        const values = new Array(count);
        for (let i = 0; i < count; i++) {
            values[i] = element;
        }
        return values;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 0,
    });
};
const repeat2 = (element, count, delay) => {
    const generator = async () => {
        const values = new Array(count);
        for (let i = 0; i < count; i++) {
            values[i] = new Promise((resolve) => setTimeout(() => resolve(element), delay));
        }
        return values;
    };
    return new BasicParallelEnumerable({
        generator,
        type: 2,
    });
};
